import { render, staticRenderFns } from "./BaixaItemBemConsumoList.vue?vue&type=template&id=5c058536"
import script from "./BaixaItemBemConsumoList.vue?vue&type=script&lang=js"
export * from "./BaixaItemBemConsumoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports